import { Enlog } from '@encarpkg/shared';
import usePixel from 'app/hook/common/usePixel';
import useDetailPage from 'app/hook/cars/useDetailPage';
import appsflyerEvent from 'app/libs/appsflyer';

function useLeadMarketing() {
	const { rtBrazeClickAttribute } = useDetailPage();
	const { excuteKakaoPixel, excuteFbPixel } = usePixel();

	const onLeadMarketing = (type) => {
		// 브레이즈: 상세 외에서도 사용됨 (검수리포트, 비용계산기)
		switch (type) {
			case 'meetgoCall': {
				// 믿고 전화 문의: 브레이즈 삭제
				break;
			}
			case 'meetgoVideo': {
				// 믿고 화상 상담 신청: 브레이즈 삭제
				break;
			}
			case 'meetgoLink': {
				// 믿고방문 (믿고센터)
				const braze = {
					customEvent: {
						name: 'lead_mgcentervisit',
						param: {
							date: new Date().toISOString(),
						},
					},
					customAttribute: {
						name: '신청하기',
						param: rtBrazeClickAttribute(),
					},
				};
				Enlog().enloggingJsonData({ braze });
				appsflyerEvent('lead_mgad_request_bn_end');
				break;
			}
			case 'encarSafetyZone': {
				// 믿고방문 (안심거래존)
				const braze = {
					customEvent: {
						name: 'lead_safezonevisit',
						param: {
							date: new Date().toISOString(),
						},
					},
					customAttribute: {
						name: '신청하기',
						param: rtBrazeClickAttribute(),
					},
				};
				Enlog().enloggingJsonData({ braze });
				break;
			}
			case 'homeService': {
				// 믿고배송 (홈서비스 신청, 집앞으로 배송받기)
				const braze = {
					customEvent: {
						name: 'lead_delivery',
						param: {
							date: new Date().toISOString(),
						},
					},
					customAttribute: {
						name: '신청하기',
						param: rtBrazeClickAttribute(),
					},
				};
				Enlog().enloggingJsonData({ braze });
				appsflyerEvent('lead_hs_request_bn_end');
				break;
			}
			case 'normalCall': {
				// 일반 광고 전화 문의: 브레이즈 삭제
				break;
			}
			case 'normalChat': {
				// 일반 광고 메시지 문의: 브레이즈 삭제
				break;
			}
			default:
				break;
		}
		// 리드 공통
		appsflyerEvent('lead_total_bn_end');
		excuteKakaoPixel('lead_total_bn_end');
		excuteFbPixel('lead_total_bn_end');
	};

	return {
		onLeadMarketing,
	};
}

export default useLeadMarketing;
